import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import { compose, defaultProps } from 'recompose';

export default compose(
  defaultProps({
    utils: MomentUtils,
    moment,
  })
)(MuiPickersUtilsProvider);
